// In-memory, per-tab source of truth for the active Outlet-Id used by
// apiOutletClient. It is owned by AuthProvider, which mirrors the React
// `outlet` state into it whenever the outlet changes (switch / restore /
// logout).
//
// Why in-memory instead of reading localStorage at request time: localStorage
// is shared across every tab, so a second tab switching outlets would silently
// change what THIS tab's in-flight requests target (wrong-outlet submits). A
// plain module variable lives in this tab's JS heap only, so each tab keeps its
// own active outlet. localStorage stays the reload-seed (see auth-provider),
// never the live request source.
let activeOutletId = null;

export const setActiveOutletId = (id) => {
  activeOutletId = id ?? null;
};

export const getActiveOutletId = () => activeOutletId;
